import {
  AccountDetails,
  BankStatement,
  BankStatementDetails,
  CreditDebit,
  DailyCashBalance,
  DrawRequests,
  CashBalance,
  AdminManagement,
  CashManagement,
  CapitalCall,
  ShortTermLoanPlan,
  OutstandingCheckList
} from "../pages";
import {
  DollarCircleOutlined,
  BankOutlined,
  CreditCardOutlined,
  LineChartOutlined,
  BarChartOutlined,
  ContainerOutlined,
  FundOutlined,
  AuditOutlined,
  PartitionOutlined,
  ProfileOutlined,
  TeamOutlined
} from "@ant-design/icons";
import { UnauthorizedPage } from "../components";
import { Statements } from "../pages/Statements/Statements";
import { UserManagement } from "../pages/UserManagement/UserManagement";
import { LandingPage } from "../pages/LandingPage/LandingPage";
import { DrawRequestNew } from "../pages/DrawRequestNew/DrawRequestNew";
import { DrawRequestNewModal } from "../pages/DrawRequestNew/components/DrawRequestNewModal/DrawRequestNewModal";
import { PreviewApproveDenyDrawRequest } from "../pages/DrawRequestNew/pages/PreviewApproveDenyDrawRequest";

export const routes = [
  {
    key: "/cash-balance",
    element: <CashBalance />,
    label: "Cash Balance",
    icon: <DollarCircleOutlined style={{ fontSize: "1rem" }} />,
    guard: ["Treasury", "Accounting"]
  },
  {
    key: "/cash-management",
    element: <CashManagement />,
    label: "Cash Management",
    icon: <BarChartOutlined style={{ fontSize: "1rem" }} />,
    guard: ["Treasury", "Accounting"]
  },
  {
    key: "/short-term-loan-plan",
    element: <ShortTermLoanPlan />,
    label: "Short-term loan plan",
    icon: <FundOutlined style={{ fontSize: "1rem" }} />,
    guard: ["Treasury", "Accounting"]
  },
  {
    key: "/draw-requests-treasury",
    element: <DrawRequests />,
    label: "CMS Approval",
    icon: <ContainerOutlined style={{ fontSize: "1rem" }} />,
    guard: ["Treasury"]
  },
  /**======================
   *    new draw request
   *========================**/
  {
    key: "/draw-requests",
    element: <DrawRequestNew />,
    label: "Payment Requests",
    icon: <ContainerOutlined style={{ fontSize: "1rem" }} />
  },
  /*==== END OF SECTION ====*/

  {
    key: "/check-list",
    element: <OutstandingCheckList />,
    label: "Outstanding Check List",
    icon: <ProfileOutlined style={{ fontSize: "1rem" }} />,
    guard: ["Treasury", "Accounting"]
  },
  {
    key: "/bank-statement",
    element: <BankStatement />,
    label: "Bank Statement",
    icon: <BankOutlined style={{ fontSize: "1rem" }} />,
    guard: ["Treasury", "Accounting"]
  },
  {
    key: "/statements",
    element: <Statements />,
    label: "CMS Statements",
    icon: <BarChartOutlined style={{ fontSize: "1rem" }} />,
    guard: ["Treasury", "Accounting"]
  },
  {
    key: "/distribution-capital-call",
    element: <CapitalCall />,
    label: "Distribution & Capital Call",
    icon: <AuditOutlined style={{ fontSize: "1rem" }} />,
    guard: ["Treasury", "Accounting"]
  },
  {
    key: "/debit-credit",
    element: <CreditDebit />,
    label: "Debit/Credit",
    icon: <CreditCardOutlined style={{ fontSize: "1rem" }} />,
    guard: ["Treasury", "Accounting"]
  },
  {
    key: "/daily-cash-balance",
    element: <DailyCashBalance />,
    label: "Daily Cash Balance",
    icon: <LineChartOutlined style={{ fontSize: "1rem" }} />,
    guard: ["Treasury", "Accounting"]
  },
  {
    key: "/admin-management",
    element: <AdminManagement />,
    label: "Admin Management",
    icon: <PartitionOutlined style={{ fontSize: "1rem" }} />,
    guard: ["Treasury", "Accounting"]
  },

  {
    key: "/bank-statement/:id",
    element: <BankStatementDetails />,
    label: "Bank Statement Details",
    skipMenuRender: true,
    guard: ["Treasury", "Accounting"]
  },

  {
    key: "/account-details/:id",
    element: <AccountDetails />,
    label: "Account Details",
    skipMenuRender: true,
    guard: ["Treasury", "Accounting"]
  },
  {
    key: "/user-management",
    element: <UserManagement />,
    label: "User Management",
    icon: <TeamOutlined style={{ fontSize: "1rem" }} />,
    guard: ["Treasury", "Accounting"]
  },
  {
    key: "/401",
    element: <UnauthorizedPage />,
    label: "Unauthorized",
    skipMenuRender: true
  }
];
export const routesOthers = [
  {
    key: "/",
    element: <LandingPage />,
    guard: []
  },

  /**======================
   *    new draw request
   *========================**/
  {
    key: "/draw-requests/new-draw-request",
    element: <DrawRequestNewModal />
  },
  {
    key: "/draw-requests/edit-draw-request/:id",
    element: <DrawRequestNewModal />
  },
  {
    key: "/draw-requests/copy-draw-request/:id",
    element: <DrawRequestNewModal />
  },
  {
    key: "/draw-requests/preview-draw-request/:id",
    element: <PreviewApproveDenyDrawRequest />
  }
  /*==== END OF SECTION ====*/
];
